// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gD8HdpNAuS3NwOxdJ7XO{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.gD8HdpNAuS3NwOxdJ7XO .Plp8nVIQBhxa1v2QYM_g{max-width:1024px;width:100%;height:100%}.gD8HdpNAuS3NwOxdJ7XO .XeK7ViISpc9WWX8k4Izo{margin:auto;height:100%;display:flex;gap:1em;justify-content:center;flex-direction:row;align-items:center}.gD8HdpNAuS3NwOxdJ7XO .XeK7ViISpc9WWX8k4Izo .Dh324BEBFvKo9kwo9P2f{flex:1;display:flex;flex-direction:column;justify-content:center;align-items:center}.gD8HdpNAuS3NwOxdJ7XO .XeK7ViISpc9WWX8k4Izo .G9SYnD3ySBbV_IYpSYJB{flex:1;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column}.gD8HdpNAuS3NwOxdJ7XO .XeK7ViISpc9WWX8k4Izo .G9SYnD3ySBbV_IYpSYJB img{flex:1}.gD8HdpNAuS3NwOxdJ7XO .XeK7ViISpc9WWX8k4Izo .G9SYnD3ySBbV_IYpSYJB p{flex:0}.gD8HdpNAuS3NwOxdJ7XO .YIWClYE53iZtVtblC_2r{font-size:12px;margin-top:1rem;color:var(--color-sa-gray)}.gD8HdpNAuS3NwOxdJ7XO .tTJvaMknMSS7mxnsG3Yu{margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center}.gD8HdpNAuS3NwOxdJ7XO .tTJvaMknMSS7mxnsG3Yu .a5Ama4Yhgf0cMCHBOHcc{flex:0;text-align:bottom}.gD8HdpNAuS3NwOxdJ7XO .tTJvaMknMSS7mxnsG3Yu p{flex:0 0}.gD8HdpNAuS3NwOxdJ7XO .tTJvaMknMSS7mxnsG3Yu strong{font-weight:500}.gD8HdpNAuS3NwOxdJ7XO .tTJvaMknMSS7mxnsG3Yu .Qjrb79nzSc6xPEz2xrrG{color:#6e32f0;font-size:14px;text-align:center;margin-top:4em;flex:0 1 20px}.gD8HdpNAuS3NwOxdJ7XO .iHt70qPcH6hC6uYkCsOc{width:100% !important;max-width:100% !important}.gD8HdpNAuS3NwOxdJ7XO .a5Ama4Yhgf0cMCHBOHcc{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"AudioSources": `gD8HdpNAuS3NwOxdJ7XO`,
	"rightComponent": `Plp8nVIQBhxa1v2QYM_g`,
	"imageSlide": `XeK7ViISpc9WWX8k4Izo`,
	"textColumn": `Dh324BEBFvKo9kwo9P2f`,
	"imageColumn": `G9SYnD3ySBbV_IYpSYJB`,
	"caption": `YIWClYE53iZtVtblC_2r`,
	"carouselItem": `tTJvaMknMSS7mxnsG3Yu`,
	"title": `a5Ama4Yhgf0cMCHBOHcc`,
	"thanks": `Qjrb79nzSc6xPEz2xrrG`,
	"image": `iHt70qPcH6hC6uYkCsOc`
};
export default ___CSS_LOADER_EXPORT___;
